export default __webpack_public_path__ + "ee3a300c7bfec666aeedc3720be6a3f5.wav";